export default "__VITE_ASSET___ZySxkFv__"